export enum LorenMeteringType {
  BAROMETRIC_PRESSURE_SENSOR = "BAROMETRIC_PRESSURE_SENSOR",
  BATTERY_STATE_OF_CHARGE_SENSOR = "BATTERY_STATE_OF_CHARGE_SENSOR",
  BATTERY_VOLTAGE_SENSOR = "BATTERY_VOLTAGE_SENSOR",
  BINARY_SENSOR = "BINARY_SENSOR",
  CO2_SENSOR = "CO2_SENSOR",
  CURRENT_SENSOR = "CURRENT_SENSOR",
  DISTANCE_SENSOR = "DISTANCE_SENSOR",
  EXTERNAL_CURRENT_SENSOR = "EXTERNAL_CURRENT_SENSOR",
  EXTERNAL_VOLTAGE_SENSOR = "EXTERNAL_VOLTAGE_SENSOR",
  FILL_LEVEL_SENSOR = "FILL_LEVEL_SENSOR",
  FLUID_FLOW_SENSOR = "FLUID_FLOW_SENSOR",
  GAS_DETECTOR = "GAS_DETECTOR",
  GEOFENCE_STATUS = "GEOFENCE_STATUS",
  GPS_TRACKER_SENSOR = "GPS_TRACKER_SENSOR",
  HCHO_SENSOR = "HCHO_SENSOR",
  HUMIDITY_SENSOR = "HUMIDITY_SENSOR",
  ILLUMINATION_SENSOR = "ILLUMINATION_SENSOR",
  LIGHT_BINARY_SENSOR = "LIGHT_BINARY_SENSOR",
  LIGHT_SENSOR = "LIGHT_SENSOR",
  MOTION_STATUS = "MOTION_STATUS",
  MOVEMENT_SENSOR = "MOVEMENT_SENSOR",
  PIR_BINARY_SENSOR = "PIR_BINARY_SENSOR",
  PM2_5_SENSOR = "PM2_5_SENSOR",
  PM10_SENSOR = "PM10_SENSOR",
  PRESENCE_SENSOR = "PRESENCE_SENSOR",
  PRESENCE_BEACON = "PRESENCE_BEACON",
  OZONE_SENSOR = "OZONE_SENSOR",
  SMOKE_DETECTOR = "SMOKE_DETECTOR",
  SOIL_TEMPERATURE_SENSOR = "SOIL_TEMPERATURE_SENSOR",
  SOIL_MOISTURE_SENSOR = "SOIL_MOISTURE_SENSOR",
  SOIL_MOISTURE_SENSOR_VWC = "SOIL_MOISTURE_SENSOR_VWC",
  TEMPERATURE_SENSOR = "TEMPERATURE_SENSOR",
  TVOC_SENSOR = "TVOC_IAQ_SENSOR",
  TVOC_M3_SENSOR = "TVOC_M3_SENSOR",
  VOLTAGE_SENSOR = "VOLTAGE_SENSOR",
  ARCING_SENSOR = "ARCING_SENSOR",
  NTL_SENSOR = "NTL_SENSOR",
  ELECTRICAL_CONDUCTIVITY_SENSOR = "ELECTRICAL_CONDUCTIVITY_SENSOR",
  IMAGE_SENSOR = "IMAGE_SENSOR",
  ITEM_COUNT_SENSOR = "ITEM_COUNT_SENSOR",

  /// metering contexts of BINARY_SENSOR mapped to types
  DOOR_WINDOW_BINARY_SENSOR = "DOOR_WINDOW_BINARY_SENSOR",
  IGNITION_BINARY_SENSOR = "IGNITION_BINARY_SENSOR",
  SMOKE_BINARY_SENSOR = "SMOKE_BINARY_SENSOR",
  TILT_BINARY_SENSOR = "TILT_BINARY_SENSOR",
  WATER_LEAK_BINARY_SENSOR = "WATER_LEAK_BINARY_SENSOR",
}

export const LorenMeteringTypeTranslation: Map<LorenMeteringType, string> =
  new Map<LorenMeteringType, string>([
    [
      LorenMeteringType.BAROMETRIC_PRESSURE_SENSOR,
      "metering_type.barometric_pressure",
    ],
    [
      LorenMeteringType.BATTERY_STATE_OF_CHARGE_SENSOR,
      "metering_type.battery_state_of_charge_sensor",
    ],
    [
      LorenMeteringType.BATTERY_VOLTAGE_SENSOR,
      "metering_type.battery_voltage_sensor",
    ],
    [LorenMeteringType.BINARY_SENSOR, "metering_type.binary"],
    [LorenMeteringType.CO2_SENSOR, "metering_type.carbon_dioxide"],
    [LorenMeteringType.CURRENT_SENSOR, "metering_type.current"],
    [LorenMeteringType.DISTANCE_SENSOR, "metering_type.distance_sensor"],
    [
      LorenMeteringType.FILL_LEVEL_SENSOR,
      "metering_type.fill_level",
    ],
    [
      LorenMeteringType.EXTERNAL_VOLTAGE_SENSOR,
      "metering_type.external_voltage_sensor",
    ],
    [
      LorenMeteringType.EXTERNAL_CURRENT_SENSOR,
      "metering_type.external_current_sensor",
    ],
    [LorenMeteringType.FLUID_FLOW_SENSOR, "metering_type.fluid_flow_sensor"],
    [LorenMeteringType.GAS_DETECTOR, "metering_type.gas"],
    [LorenMeteringType.GEOFENCE_STATUS, "metering_type.geofence_status"],
    [LorenMeteringType.GPS_TRACKER_SENSOR, "metering_type.gps_tracker"],
    [LorenMeteringType.HCHO_SENSOR, "metering_type.hcho"],
    [LorenMeteringType.HUMIDITY_SENSOR, "metering_type.humidity"],
    [LorenMeteringType.IMAGE_SENSOR, "metering_type.image_sensor"],
    [LorenMeteringType.ITEM_COUNT_SENSOR, "metering_type.item_count"],
    [LorenMeteringType.ILLUMINATION_SENSOR, "metering_type.illumination"],
    [LorenMeteringType.LIGHT_BINARY_SENSOR, "metering_type.illumination"],
    [LorenMeteringType.LIGHT_SENSOR, "metering_type.illumination"],
    [LorenMeteringType.MOTION_STATUS, "metering_type.motion_status"],
    [LorenMeteringType.MOVEMENT_SENSOR, "metering_type.movement"],
    [LorenMeteringType.OZONE_SENSOR, "metering_type.ozone"],
    [LorenMeteringType.PIR_BINARY_SENSOR, "metering_type.movement"],
    [LorenMeteringType.PM2_5_SENSOR, "metering_type.pm_2_5"],
    [LorenMeteringType.PM10_SENSOR, "metering_type.pm_10"],
    [LorenMeteringType.PRESENCE_BEACON, "metering_type.presence_beacon"],
    [LorenMeteringType.PRESENCE_SENSOR, "metering_type.presence_sensor"],
    [LorenMeteringType.SMOKE_DETECTOR, "metering_type.smoke"],
    [LorenMeteringType.SOIL_MOISTURE_SENSOR, "metering_type.soil_moisture"],
    [LorenMeteringType.SOIL_MOISTURE_SENSOR_VWC, "metering_type.soil_moisture"],
    [
      LorenMeteringType.SOIL_TEMPERATURE_SENSOR,
      "metering_type.soil_temperature",
    ],
    [LorenMeteringType.TEMPERATURE_SENSOR, "metering_type.temperature"],
    [LorenMeteringType.TVOC_SENSOR, "metering_type.tvoc"],
    [LorenMeteringType.TVOC_M3_SENSOR, "metering_type.tvoc"],
    [LorenMeteringType.VOLTAGE_SENSOR, "metering_type.voltage"],

    [
      LorenMeteringType.DOOR_WINDOW_BINARY_SENSOR,
      "asset.metering_context_door_window",
    ],
    [
      LorenMeteringType.IGNITION_BINARY_SENSOR,
      "asset.metering_context_vehicle_ignition",
    ],
    [LorenMeteringType.SMOKE_BINARY_SENSOR, "asset.metering_context_smoke"],
    [LorenMeteringType.TILT_BINARY_SENSOR, "asset.metering_context_tilt"],
    [
      LorenMeteringType.WATER_LEAK_BINARY_SENSOR,
      "asset.metering_context_water_leak",
    ],
    [LorenMeteringType.ARCING_SENSOR, "metering_type.arcing"],
    [LorenMeteringType.NTL_SENSOR, "metering_type.ntl"],
    [LorenMeteringType.ELECTRICAL_CONDUCTIVITY_SENSOR, "metering_type.electrical_conductivity"]
  ]);

export const LorenMeteringTypeDefaultDescriptions: Map<
  LorenMeteringType,
  string
> = new Map<LorenMeteringType, string>([
  [
    LorenMeteringType.BAROMETRIC_PRESSURE_SENSOR,
    "metering_type.barometric_pressure",
  ],
  [
    LorenMeteringType.BATTERY_STATE_OF_CHARGE_SENSOR,
    "dashboard.battery_state_of_charge_sensor",
  ],
  [
    LorenMeteringType.BATTERY_VOLTAGE_SENSOR,
    "dashboard.battery_voltage_sensor",
  ],
  [LorenMeteringType.BINARY_SENSOR, "dashboard.binary_state"],
  [LorenMeteringType.CURRENT_SENSOR, "metering_type.current"],
  [LorenMeteringType.CO2_SENSOR, "metering_type.carbon_dioxide"],
  [LorenMeteringType.DISTANCE_SENSOR, "metering_type.distance_sensor"],
  [LorenMeteringType.FILL_LEVEL_SENSOR, "metering_type.fill_level"],
  [
    LorenMeteringType.EXTERNAL_CURRENT_SENSOR,
    "metering_type.external_current_sensor",
  ],
  [
    LorenMeteringType.EXTERNAL_VOLTAGE_SENSOR,
    "dashboard.external_voltage_sensor",
  ],
  [LorenMeteringType.FLUID_FLOW_SENSOR, "metering_type.fluid_flow_sensor"],
  [LorenMeteringType.GAS_DETECTOR, "metering_type.gas"],
  [LorenMeteringType.GEOFENCE_STATUS, "metering_type.geofence_status"],
  [LorenMeteringType.GPS_TRACKER_SENSOR, "metering_type.gps_tracker"],
  [LorenMeteringType.HCHO_SENSOR, "metering_type.hcho"],
  [LorenMeteringType.HUMIDITY_SENSOR, "dashboard.environment_data"],
  [LorenMeteringType.ILLUMINATION_SENSOR, "asset.light"],
  [LorenMeteringType.LIGHT_BINARY_SENSOR, "asset.light"],
  [LorenMeteringType.LIGHT_SENSOR, "asset.light"],
  [LorenMeteringType.MOTION_STATUS, "meteryng_type.motion_status"],
  [LorenMeteringType.MOVEMENT_SENSOR, "metering_type.movement"],
  [LorenMeteringType.OZONE_SENSOR, "metering_type.ozone"],
  [LorenMeteringType.PIR_BINARY_SENSOR, "metering_type.movement"],
  [LorenMeteringType.PM2_5_SENSOR, "metering_type.pm_2_5"],
  [LorenMeteringType.PM10_SENSOR, "metering_type.pm_10"],
  [LorenMeteringType.PRESENCE_BEACON, "metering_type.presence_beacon"],
  [LorenMeteringType.PRESENCE_SENSOR, "metering_type.presence_sensor"],
  [LorenMeteringType.SMOKE_DETECTOR, "metering_type.smoke"],
  [LorenMeteringType.SOIL_MOISTURE_SENSOR, "dashboard.soil_data"],
  [LorenMeteringType.SOIL_TEMPERATURE_SENSOR, "dashboard.soil_data"],
  [LorenMeteringType.TEMPERATURE_SENSOR, "dashboard.environment_data"],
  [LorenMeteringType.TVOC_M3_SENSOR, "metering_type.tvoc"],
  [LorenMeteringType.TVOC_SENSOR, "metering_type.tvoc"],
  [LorenMeteringType.VOLTAGE_SENSOR, "metering_type.voltage"],
  [LorenMeteringType.ARCING_SENSOR, "metering_type.arcing"],
  [LorenMeteringType.NTL_SENSOR, "metering_type.ntl"],

  [
    LorenMeteringType.DOOR_WINDOW_BINARY_SENSOR,
    "asset.metering_context_door_window",
  ],
  [
    LorenMeteringType.IGNITION_BINARY_SENSOR,
    "asset.metering_context_vehicle_ignition",
  ],
  [LorenMeteringType.SMOKE_BINARY_SENSOR, "asset.metering_context_smoke"],
  [LorenMeteringType.TILT_BINARY_SENSOR, "asset.metering_context_tilt"],
  [
    LorenMeteringType.WATER_LEAK_BINARY_SENSOR,
    "asset.metering_context_water_leak",
  ],
]);
